// React
import React, { useEffect, useState } from "react";
// React
// CSS
import styles from "./Step2.module.css";
// CSS
// Services
import { verifySMS_Service } from "../../../Services/Register/post/verifySMS_Service";
import { login_Service } from "../../../Services/Login/get/login_Service";
import { toast } from "react-toastify";
import Spinner from "../../../Utils/Spinner/Spinner";
import { sendFirebaseToken_Service } from "../../../Services/Common/sendFirebaseToken_Service";
import Swal from "sweetalert2";
import { logo_1 } from "../../../Images/images";
// Services

type Step2Props = {
  setUserToken: React.Dispatch<React.SetStateAction<string>>;
  userPhoneNumber: number;
  formStep: number;
  isPending: boolean;
  setIsPending: React.Dispatch<React.SetStateAction<boolean>>;
  setFormStep: React.Dispatch<React.SetStateAction<1 | 2 | 3>>;
};

const Step2: React.FunctionComponent<Step2Props> = ({
  formStep,
  setUserToken,
  userPhoneNumber,
  isPending,
  setFormStep,
  setIsPending,
}) => {
  const [timeCounter, setTimeCounter] = useState<number>(60);
  const [userCode, setUserCode] = useState<string>("");
  const [_isPending, _setIsPending] = useState<boolean>(false);
  //s
  useEffect(() => {
    setIsPending(false);
  }, [setIsPending]);
  useEffect(() => {
    const timeOuts: NodeJS.Timeout[] = [];
    if (formStep === 2) {
      const timeOut: NodeJS.Timeout = setTimeout(() => {
        setTimeCounter((prevState) => prevState - 1);
      }, 1000);
      timeOuts.push(timeOut);
    }
    if (timeCounter === 0) {
      timeOutRemover(timeOuts);
    }
    return () => {
      timeOutRemover(timeOuts);
    };
  }, [formStep, timeCounter]);
  //
  function timeOutRemover(timeOuts: NodeJS.Timeout[]): void {
    for (let i = 0; i <= timeOuts.length; i++) {
      clearTimeout(timeOuts[i]);
    }
  }
  return (
    <>
      <div
        className={`${styles.step2Container} flex flex-col items-center justify-start px-4 py-2 bg-white rounded-xl relative`}
      >
        <img src={logo_1} alt="" className={`${styles.image} rounded-lg`} />
        <input
          type="number"
          placeholder="کد 4 رقمی"
          className={`rounded-2xl my-4 py-3 w-full dark:!text-black`}
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setUserCode(e.currentTarget.value);
          }}
        />
        <button
          className={`${styles.submitBtn} w-full rounded-2xl py-3 mt-4 mb-8 text-white flex items-center justify-center font-bold`}
          onClick={() => {
            if (userCode.length !== 4) {
              toast("کد را به شکل درست وارد کنید");
              return;
            }
            if (_isPending) {
              toast("در حال پردازش درخواست قبلی");
              return;
            }
            _setIsPending(true);
            verifySMS_Service(userPhoneNumber, userCode)
              .then(({ status, data: { token } }) => {
                if (status === 200) {
                  _setIsPending(false);
                  setUserToken(token);
                  localStorage.setItem(
                    "amoozeshMeliToken",
                    JSON.stringify(token)
                  );
                  sendFirebaseToken_Service(
                    JSON.parse(
                      localStorage.getItem("amoozeshMeliFirebaseToken") ||
                        JSON.stringify("")
                    ),
                    token
                  );
                  setFormStep(3);
                  return;
                } else {
                  return;
                }
              })
              .catch((err) => {
                if (err.response.data.error.message === "code is't valid!") {
                  toast("کد اشتباه است");
                  _setIsPending(false);
                  return;
                }
                toast(
                  err.response.data.message
                    ? err.response.data.message
                    : err.message
                );
              });
          }}
        >
          {_isPending ? (
            <>
              <Spinner />
            </>
          ) : (
            <>بررسی کد</>
          )}
        </button>
        <p className="mb-2">کد فعالسازی به {userPhoneNumber} ارسال شد</p>
        <button
          className={`${styles.retryBtn} text-sm ${
            timeCounter !== 0
              ? "text-gray-500 cursor-default"
              : "text-black cursor-pointer"
          }`}
          onClick={() => {
            if (timeCounter !== 0) {
              toast("زمان انتظار هنوز تمام نشده");
              return;
            }
            login_Service(userPhoneNumber)
              .then(({ status }) => {
                if (status === 200 || 201) {
                  toast("کد دوباره ارسال شد");
                  setTimeCounter(60);
                }
              })
              .catch((err) => {
                toast("مشکلی در ارسال کد پیش آمده");
                Swal.fire({ icon: "error", title: err.response.data.message });
              });
          }}
        >
          {timeCounter !== 0 ? (
            <>
              در صورت دریافت نکردن پیامک بعد از {timeCounter} ثانیه اینجا کلیک
              کنید
            </>
          ) : (
            <>در صورت دریافت نکردن پیامک اینجا کلیک کنید</>
          )}
        </button>
      </div>
    </>
  );
};

export default Step2;
